/**
 * parseIngredientLines(text)
 *
 * Mirror of the backend `_parse_ingredient_line` regex (in
 * /app/backend/routes/planner.py) so a user pasting an ingredient list on
 * the client gets the exact same qty/unit/name split we'd derive
 * server-side from a markdown "## Ingredients" section.
 *
 * Skips blank lines, strips common markdown bullet prefixes ("- ", "* ",
 * "1. ", "•") and comma/newline separators.
 */
const UNIT_RE = new RegExp(
  "^\\s*([\\d/.\\s¼½¾⅓⅔⅛⅜⅝⅞]+)?\\s*" +
    "(cups?|cup|tbsp|tsp|teaspoons?|tablespoons?|oz|ounces?|lb|lbs|pounds?|g|grams?|kg|ml|l|liters?|litres?|cans?|jars?|cloves?|slices?|pinch|handful|bunch|stalks?|sprigs?|packages?|packets?|bottles?)\\.?\\s+(?:of\\s+)?(.+)$",
  "i",
);
const QTY_ONLY_RE = /^\s*([\d/.\s¼½¾⅓⅔⅛⅜⅝⅞]+)\s+(.+)$/;

function parseLine(raw) {
  // Strip bullet prefixes + trailing markup
  let line = raw
    .replace(/^\s*(?:[-*+•]|\d+[.)])\s+/, "")
    .replace(/\s+$/g, "")
    .trim();
  if (!line) return null;
  const m = line.match(UNIT_RE);
  if (m) {
    return {
      qty: (m[1] || "").trim(),
      unit: (m[2] || "").trim(),
      name: (m[3] || "").trim(),
    };
  }
  const m2 = line.match(QTY_ONLY_RE);
  if (m2) return { qty: m2[1].trim(), unit: "", name: m2[2].trim() };
  return { qty: "", unit: "", name: line };
}

export default function parseIngredientLines(text) {
  if (!text) return [];
  // Split on newlines; also split on ";" and " AND " because paste from
  // some sources arrives as a single paragraph.
  const rawLines = String(text)
    .split(/\r?\n|;|\s+\band\b\s+/i)
    .map((l) => l.trim())
    .filter(Boolean);
  return rawLines.map(parseLine).filter(Boolean);
}
